import { Color } from './color';

/**
 * Une lame de la configuration
 */
export class ConfigurationBoard {
  id?: string;

  /**
   * Nombre de lames obligatoire à afficher si c'est une configuration avec de la mixité de lame
   */
  boardNumber?: number;

  /**
   * Ordre dans lequel l'afficher
   */
  order: number;

  /**
   * Type de la lame lié (correspond à boardId dans le vocabulaire front)
   */
  fenceTypeId: number;

  /**
   * Lame liée (correspond à colorId dans le vocabulaire front)
   */
  boardId?: number;

  /**
   * Longueur de la lame liée
   */
  boardWidth?: number;

  /**
   * Hauteur de la lame liée
   */
  boardHeight?: number;

  /**
   * Nom de la lame en français
   */
  boardNameFr?: string;

  /**
   * Nom de la lame en anglais
   */
  boardNameEn?: string;

  constructor(order: number, fenceTypeId: number, board?: Color, boardNumber?: number) {
    this.order = order;
    this.fenceTypeId = fenceTypeId;
    this.boardId = board?.id;
    this.boardWidth = board?.width;
    this.boardHeight = board?.height;
    this.boardNameFr = board?.nameFr;
    this.boardNameEn = board?.nameEn;
    this.boardNumber = boardNumber;
  }
}
